module.exports = __webpack_public_path__ + "static/media/c56.7bebba29.png";